import { Grid } from '@mui/material'

import { LinkCard, LinkCardProps } from './LinkCard'

interface LinkCardSetProps {
  data: LinkCardProps[]
  imgHeight?: number
}

export const LinkCardSet = (props: LinkCardSetProps) => {
  const { data, imgHeight = undefined } = props
  return (
    <Grid container spacing={5} sx={{ width: '100%', margin: 'none !important', justifyContent: 'flex-start' }}>
      {data.map((card, index) => {
        const { links, image, title, body } = card
        return (
          <Grid size={{ xs: 12, sm: 6, md: 3 }} key={index}>
            <LinkCard links={links} image={image} title={title} body={body} imgHeight={imgHeight} />
          </Grid>
        )
      })}
    </Grid>
  )
}
